import de_DE from './de_DE.json';
import en_US from './en_US.json';

export const commonMessages = {
  de_DE,
  en_US
};
